import * as React from 'react';
import { useEffect, useRef } from 'react';

export interface ObserverProps {
  children: React.ReactElement | React.ReactElement[];
  intersectionAction?: () => void;
  /*If singleObservation is true then the child would get unobserved after the first intersection itself*/
  singleObservation?: boolean;
  startObserve?: boolean;
  threshold?: number;
  intersectionRatio?: number;
}

export const Observer: React.FunctionComponent<ObserverProps> = ({
  intersectionAction,
  singleObservation = true,
  startObserve = true,
  threshold = 1.0,
  intersectionRatio = 1,
  children
}: ObserverProps) => {
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    const domRef = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= intersectionRatio) {
          intersectionAction();
          if (singleObservation) {
            observer.unobserve(domRef as Element);
          }
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [threshold]
      }
    );

    startObserve && observer.observe(domRef as Element);

    return () => {
      observer.unobserve(domRef as Element);
    };
  }, [startObserve, intersectionAction, intersectionRatio, singleObservation, threshold]);

  return (
    <div ref={ref} data-test-id="intersection-observer">
      {children}
    </div>
  );
};
